import React,{Fragment} from 'react';
import {
    allowNumericWithdecimal,
    getPaymentGatewayCharges, 
    getPaymentGateway,
    convertTwoDecimalPoint, 
    getLoginParent} from "../../../server/util";
class BillBoard extends React.Component{
    render(){
        const charges=(getPaymentGatewayCharges(this.props.schoolId,this.props.totalAmount,true));
        return(
            <Fragment>
                {
                    Object.values(this.props.studentPackages||{}).map(pack=>{
                       return (pack||[]).map(item=>{
                            return <div>
                            <span className="charge">{item.charge}</span><span className="price">{`${this.props.currency} ${convertTwoDecimalPoint(item.amount,2)}`}</span>
                            </div>
                        })
                    })
                }                
                <div className="footer">
                    {/* <span className="charge">Transaction Charges</span><span className="price">{`${this.props.currency} ${convertTwoDecimalPoint(charges)}`}</span><br /> 
                    <span className="charge">Total</span><span className="price">{`${this.props.currency} ${convertTwoDecimalPoint((parseFloat(this.props.totalAmount)+ parseFloat(charges)),2)}`}</span>*/}
                    <span className="charge">Total</span><span className="price">{`${this.props.currency} ${convertTwoDecimalPoint((parseFloat(this.props.totalAmount)),2)}`}</span>
                </div>
            </Fragment>
        )
    }

}
export default BillBoard;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/billBoard.jsx